<template>
  <div>
    <!-- 图标 -->
    <div class="houseBtn">
      <a-button
        style="border: none; background-color: #fff; padding: 0px"
        class="icon"
        @click="visible = true"
        v-if="(HousesData.dishType !== '1' && isCeive) || HousesData.dishType == '3'"
      >
        <div class="icon-i icon-ii" :class="{ unclickBgc: HousesData.dishType === '1' }">
          <i class="iconfont icon-bianji1"></i>
        </div>
        <span class="color31c170" :class="{ unclickColor: HousesData.dishType === '1' }">认领</span>
      </a-button>
      <!-- 全部房源进入 离职人员  具备LZXG权限 不是公盘 -->
      <div class="btnHouse" @click="updateHouseDishTypePrivateToCompany" v-if="HousesData.dishType !== '1'&&this.$route.query.activeNum === '1'&&this.$route.query.userStatus==='1'&& lzxgPorims">
        <div class="Claim">
          <i class="iconfont icon-genjin"></i>
        </div>
        <div class="clainFont">转公盘</div>
      </div>

      <template v-if="HousesData.dishType">
        <template v-if="HousesData.accendantId === uid || controlJurisdiction">
          <div class="btnHouse" @click="handleLook">
            <div class="Claim">
              <i class="iconfont icon-chakan"></i>
            </div>
            <div class="clainFont">查看</div>
          </div>
        </template>
        <!-- 公盘都能查看 公盘可以选择跟进还是不跟进 -->
        <template v-else-if="HousesData.dishType !== '1'">
          <div class="btnHouse" @click="handleLook">
            <div class="Claim">
              <i class="iconfont icon-chakan"></i>
            </div>
            <div class="clainFont">查看</div>
          </div>
        </template>
        <template v-else>
          <!-- controlJurisdiction 添加所有AB店长权限 -->
          <div class="btnHouse" @click="handleLook" v-if="controlJurisdiction">
            <div class="Claim">
              <i class="iconfont icon-chakan"></i>
            </div>
            <div class="clainFont">查看</div>
          </div>
          <div class="btnHouse" @click="handleLook" v-else>
            <div v-hasPermi="['houses:lessorInfo:query']">
              <div class="Claim">
                <i class="iconfont icon-chakan"></i>
              </div>
              <div class="clainFont">查看</div>
            </div>
          </div>
        </template>
        <!-- 具备A店长权限 或者上架 或者下架状态   并且房源类型不能为门店公盘 公司公盘 -->
        <div
          v-if="
            (AManager || HousesData.houseStatus === '6' || HousesData.houseStatus === '1') &&
              HousesData.dishType !== '3' &&
              HousesData.dishType !== '2'
          "
          style="display: flex"
        >
          <div
            class="btnHouse"
            @click="getEditHouseInfoStatus(6)"
            v-if="( HousesData.accendantId === uid || controlJurisdiction || managePermision ) && HousesData.houseStatus !== '6'"
          >
            <div class="Claim">
              <img class="btn_svg" :src="$invalidSvg" alt="下架" />
            </div>
            <div class="clainFont">下架</div>
          </div>
          <!-- 操作上架的权限配置  具备所有AB店长权限或者具备总经理角色 或者 具备HousesData.accendantId === uid    并且不能为上架 -->
          <div
            class="btnHouse"
            @click="getEditHouseInfoStatus(1)"
            v-if="( HousesData.accendantId === uid || controlJurisdiction || managePermision ) && HousesData.houseStatus !== '1'"
          >
            <div class="Claim">
              <img class="btn_svg" :src="$validSvg" alt="上架" />
            </div>
            <div class="clainFont">上架</div>
          </div>
        </div>
      </template>

      <template v-if="HousesData.dishType === '1'">
        <div class="btnHouse" @click="houseEdit" v-if="HousesData.accendantId === uid || controlJurisdiction">
          <!-- v-hasPermi="['houses:houseInfo:edit']" -->
          <div class="Claim">
            <i class="iconfont icon-bianji1"></i>
          </div>
          <div class="clainFont">编辑</div>
        </div>

        <div class="btnHouse" @click="followFn" v-if="HousesData.accendantId === uid || controlJurisdiction">
          <div class="Claim">
            <i class="iconfont icon-genjin"></i>
          </div>
          <div class="clainFont">写跟进</div>
        </div>

        <div class="btnHouse">
          <a-popover placement="bottomRight" v-model="ModleVisible" trigger="click">
            <a slot="content" @click="ModleVisible = false">
              <div class="btn_more" style="width: 150px">更多</div>
              <template v-if="HousesData.accendantId === uid || controlJurisdiction">
                <!-- controlJurisdiction 添加所有AB店长权限 -->
                <div v-if="controlJurisdiction">
                  <a-divider style="margin: 9px 0" />
                  <div v-if="HousesData.identityKey === 'N'" class="btn_more" @click="showuploadmoadl(6)">上传钥匙</div>
                  <div v-else class="btn_more" @click="showuploadmoadl(6)"><span></span> 交接钥匙</div>
                  <a-divider style="margin: 9px 0" />
                  <div v-if="HousesData.isEntrust === 'N'" class="btn_more" @click="showuploadmoadl(7)">上传委托</div>
                  <a-divider v-if="HousesData.isEntrust === 'N'" style="margin: 9px 0" />

                  <div @click="Editor(1, '转维护人')" class="btn_more">转维护人</div>
                  <a-divider style="margin: 9px 0" />

                  <div
                    @click="getEditHouseInfoStatus(3)"
                    v-if="HousesData.houseStatus !== '3' && AManager"
                    class="btn_more"
                  >
                    自行成交
                  </div>
                  <a-divider style="margin: 9px 0" v-if="HousesData.houseStatus !== '3' && AManager" />

                  <div
                    @click="getEditHouseInfoStatus(4)"
                    v-if="HousesData.houseStatus !== '4' && AManager"
                    class="btn_more"
                  >
                    无效
                    <!-- 转为错误 -->
                  </div>
                  <a-divider style="margin: 9px 0" v-if="HousesData.houseStatus !== '4' && AManager" />

                  <div
                    class="btn_more"
                    @click="editIdentityHandle('1', HousesData.identityFive)"
                    v-if="
                      (HousesData.accendantId === uid || controlJurisdiction) &&
                        HousesData.dishType === '1' &&
                        HousesData.houseStatus === '1'
                    "
                  >
                    <span v-if="HousesData.identityFive === 'Y'"> 取消五房 </span>
                    <span v-else> 点亮五房 </span>
                  </div>
                  <a-divider
                    v-if="
                      (HousesData.accendantId === uid || controlJurisdiction) &&
                        HousesData.dishType === '1' &&
                        HousesData.houseStatus === '1'
                    "
                    style="margin: 9px 0"
                  />

                  <div
                    class="btn_more"
                    @click="editIdentityHandle('3', HousesData.identityExcellent)"
                    v-if="
                      (HousesData.accendantId === uid || controlJurisdiction) &&
                        HousesData.dishType === '1' &&
                        HousesData.houseStatus === '1'
                    "
                  >
                    <span v-if="HousesData.identityExcellent === 'Y'"> 取消优质 </span>
                    <span v-else> 点亮优质 </span>
                  </div>
                  <a-divider
                    v-if="
                      (HousesData.accendantId === uid || controlJurisdiction) &&
                        HousesData.dishType === '1' &&
                        HousesData.houseStatus === '1'
                    "
                    style="margin: 9px 0"
                  />
                  <div @click="getSynchronization" class="btn_more">一键同步</div>
                </div>

                <div v-else>
                  <div v-hasPermi="['houses:statusRecord:add']">
                    <a-divider style="margin: 9px 0" />
                    <div v-if="HousesData.identityKey === 'N'" class="btn_more" @click="showuploadmoadl(6)">
                      上传钥匙
                    </div>
                    <div v-else class="btn_more" @click="showuploadmoadl(6)"><span></span> 交接钥匙</div>
                    <a-divider style="margin: 9px 0" />
                    <div v-if="HousesData.isEntrust === 'N'" class="btn_more" @click="showuploadmoadl(7)">上传委托</div>
                    <a-divider v-if="HousesData.isEntrust === 'N'" style="margin: 9px 0" />

                    <div @click="Editor(1, '转维护人')" class="btn_more" v-hasPermi="['houses:houseInfo:accendant']">
                      转维护人
                    </div>
                    <a-divider style="margin: 9px 0" v-hasPermi="['houses:houseInfo:accendant']" />

                    <div
                      @click="getEditHouseInfoStatus(3)"
                      v-if="HousesData.houseStatus !== '3' && AManager"
                      class="btn_more"
                    >
                      自行成交
                    </div>
                    <a-divider style="margin: 9px 0" v-if="HousesData.houseStatus !== '3' && AManager" />

                    <div
                      @click="getEditHouseInfoStatus(4)"
                      v-if="HousesData.houseStatus !== '4' && AManager"
                      class="btn_more"
                    >
                      无效
                      <!-- 转为错误 -->
                    </div>
                    <a-divider style="margin: 9px 0" v-if="HousesData.houseStatus !== '4' && AManager" />

                    <div
                      class="btn_more"
                      @click="editIdentityHandle('1', HousesData.identityFive)"
                      v-if="
                        HousesData.accendantId === uid && HousesData.dishType === '1' && HousesData.houseStatus === '1'
                      "
                    >
                      <span v-if="HousesData.identityFive === 'Y'"> 取消五房 </span>
                      <span v-else> 点亮五房 </span>
                    </div>
                    <a-divider
                      v-if="
                        HousesData.accendantId === uid && HousesData.dishType === '1' && HousesData.houseStatus === '1'
                      "
                      style="margin: 9px 0"
                    />

                    <div
                      class="btn_more"
                      @click="editIdentityHandle('3', HousesData.identityExcellent)"
                      v-if="
                        HousesData.accendantId === uid && HousesData.dishType === '1' && HousesData.houseStatus === '1'
                      "
                    >
                      <span v-if="HousesData.identityExcellent === 'Y'"> 取消优质 </span>
                      <span v-else> 点亮优质 </span>
                    </div>
                    <a-divider
                      v-if="
                        HousesData.accendantId === uid && HousesData.dishType === '1' && HousesData.houseStatus === '1'
                      "
                      style="margin: 9px 0"
                    />
                    <div @click="getSynchronization" class="btn_more">一键同步</div>
                  </div>
                </div>
              </template>
              <template v-if="HousesData.houseStatus === '1'">
                <!-- controlJurisdiction 添加所有AB店长权限 -->
                <div v-if="false && controlJurisdiction">
                  <a-divider style="margin: 9px 0" />
                  <div class="btn_more" @click="editIdentityHandle('2', HousesData.identityAlone)">
                    <span v-if="HousesData.identityAlone === 'Y'"> 取消独家 </span>
                    <span v-else> 点亮独家 </span>
                  </div>
                </div>
                <div v-else>
                  <a-divider v-hasPermi="['house:houseInfo:only']" style="margin: 9px 0" />
                  <div
                    v-hasPermi="['house:houseInfo:only']"
                    class="btn_more"
                    @click="editIdentityHandle('2', HousesData.identityAlone)"
                  >
                    <span v-if="HousesData.identityAlone === 'Y'"> 取消独家 </span>
                    <span v-else> 点亮独家 </span>
                  </div>
                </div>
              </template>

            </a>

            <div class="gdicon">
              <div class="Moeldtb">
                <i class="iconfont icon-gengduo"></i>
              </div>
              <div class="Moeld">更多</div>
            </div>
          </a-popover>
        </div>
      </template>
    </div>

    <!-- 认领弹窗 -->
    <ClaimTK
      :visible="visible"
      :resourceId="Number(houseId)"
      :isOpenReceiveAudit="HousesData.isOpenReceiveAudit"
      :rentSaleType="this.rentSaleType"
      @closeTK="closeTK"
    ></ClaimTK>
    <!-- 跟进 -->
    <FollowUp
      :isFollow="followShow"
      :rentSaleType="this.rentSaleType"
      @closeModal="closeModalFollowUp"
      resourceType="1"
    ></FollowUp>
    <!-- 查看弹窗 -->
    <a-modal
      v-model="lookShow"
      title="查看"
      id="lookModel"
      :footer="null"
      :maskClosable="false"
      :keyboard="false"
      :closable="iscloseBtn"
    >
      <div class="look">
        <div class="owner">业主</div>
        <div class="msg">
          <div v-for="item in ownerMsgList" :key="item.id">
            <p>{{ item.lessorsName }}</p>
            <p>{{ item.lessorsPhone }}</p>
          </div>
        </div>
      </div>
      <div v-if="!iscloseBtn" class="look_goFollowUpBtn" @click="goFollowUpBtn">去跟进 ></div>
    </a-modal>
    <!--上传钥匙弹出框-->
    <a-modal :visible="uploadmodal" @cancel="uploadmodal = false" :title="keyTitle" @ok="uploadK" :centered="true">
      <a-form-model-item label="收钥匙团队">
        <a-tree-select
          v-model="KeysList.collectKeyTeamId"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
          :tree-data="deptOptions"
          placeholder="请选择收钥匙团队"
          :replaceFields="replaceFields"
          tree-default-expand-all
          @change="handleChangeTreekeys"
        >
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="收钥匙人员">
        <a-select
          v-model="KeysList.collectKeyUserId"
          @dropdownVisibleChange="handleOptionkeys($event)"
          placeholder="请选择收钥匙人员"
          style="width: 100%"
        >
          <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
            {{ item.nickName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="收钥匙日期">
        <a-date-picker
          v-model="KeysList.recordTime"
          show-time
          type="date"
          placeholder="请选择收钥匙日期"
          style="width: 100%"
        />
      </a-form-model-item>
    </a-modal>
    <!--上传委托-->
    <a-modal
      :visible="uploadEntrust"
      @cancel="uploadEntrust = false"
      v-if="uploadEntrust"
      wrapClassName="modalUploadEntrust"
      :title="entrustTitle"
      @ok="uploadTrust"
      :getContainer="() => refHtml"
      :centered="true"
    >
      <a-form-model-item label="委托时间">
        <a-date-picker
          v-model="entrust.recordTime"
          valueFormat="YYYY-MM-DD hh:mm:ss"
          format="YYYY-MM-DD hh:mm:ss"
          show-time
          type="date"
          placeholder="请选择委托时间"
          style="width: 100%"
        />
      </a-form-model-item>
      <a-textarea
        v-model="entrust.recordContent"
        placeholder="请输入委托内容"
        :autoSize="true"
        style="width: 100%; height: 50px; border-radius: 10px"
      />
      <a-row style="margin-top: 15px">
        <a-col :span="12">
          <h4>委托书</h4>
          <div class="uploads">
            <upload-cmp
              :fileName="
                entrustAccessoryFile1 && entrustAccessoryFile1.originalName ? entrustAccessoryFile1.originalName : ''
              "
              :img-url="entrustAccessoryFile1 && entrustAccessoryFile1.fileName ? entrustAccessoryFile1.fileName : ''"
              type="image"
              :fileTypesss="fileTypesss"
              @fileUrlFn="entrust1FileUrlFn"
            ></upload-cmp>
            <a-input v-show="1 === 2" v-model="entrust.entrustFileIds" placeholder="请输入" />
          </div>
        </a-col>
        <a-col :span="12">
          <h4>产权证</h4>
          <div class="uploads">
            <upload-cmp
              :fileTypesss="fileTypesss"
              :fileName="
                entrustAccessoryFile2 && entrustAccessoryFile2.originalName ? entrustAccessoryFile2.originalName : ''
              "
              :img-url="entrustAccessoryFile2 && entrustAccessoryFile2.fileName ? entrustAccessoryFile2.fileName : ''"
              type="image"
              @fileUrlFn="entrust2FileUrlFn"
            ></upload-cmp>
            <a-input v-show="1 === 2" v-model="entrust.propertyCertificateIds" placeholder="请输入" />
          </div>
        </a-col>
      </a-row>
    </a-modal>
    <!--编辑人员弹窗-->
    <a-modal
      :visible="editorShow"
      @cancel="editorShow = false"
      :title="deitMaintainerTitle"
      @ok="editStaff"
      :centered="true"
    >
      <a-form-model-item label="人员团队名称">
        <a-tree-select
          v-model="fromStaff.keyTeam"
          style="width: 100%"
          :tree-data="deptOptions"
          placeholder="请选择人员团队名称"
          :dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
          :replaceFields="replaceFields"
          tree-default-expand-all
          @change="handleChangeTreeedit"
        ></a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="人员名称">
        <a-select
          v-model="fromStaff.ketemp"
          @dropdownVisibleChange="handleOptionedit($event)"
          placeholder="请选择人员名称"
          style="width: 100%"
        >
          <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
            {{ item.nickName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-modal>
  </div>
</template>
<script>
import ClaimTK from '@/components/modal/ClaimTK.vue'
import { treeSelectMixin } from '@/mixin/treeSelect'
import FollowUp from '@/components/modal/FollowUp.vue'
import UploadCmp from '@/components/UploadCmp/index'
import { houseInfoSaleidentity, houseInfoSaleAccendant } from '@/api/system/houses/houseSale'
import houseApi, { userSeeRecord } from '@/api/system/houses/house.js'

export default {
  mixins: [treeSelectMixin],
  data () {
    return {
      // 房源详细信息
      HousesData: {},
      fileTypesss: 'pdf',
      lookShow: false,
      ownerMsgList: [], // 业主信息
      iscloseBtn: false, // 查看框的关闭按钮
      // 认领弹窗
      visible: false,
      deitMaintainerTitle: '编辑人员', // 编辑人员 修改委托人的弹窗
      entrustTitle: '上传委托',
      keyTitle: '上传钥匙',
      ModleVisible: false,
      // 跟进
      followShow: false,
      // 上传钥匙弹出框
      uploadmodal: false,
      // 上传委托
      uploadEntrust: false,
      // 编辑人员
      editorShow: false,
      staffList: [],
      // 编辑人员名称
      editStaffList: [],
      RelaInfoPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }, // 相关人员查询分页参数
      RelaInfotabledata: [], // 相关人员数据
      deitMaintainerTitleremindfromlist: '编辑人员', // 编辑人员 修改委托人的弹窗
      // 编辑相关人员
      fromStaff: {
        keyTeam: '',
        ketemp: ''
      },
      // 上传钥匙
      KeysList: {
        collectKeyTeamId: '', // 收钥匙团队
        collectKeyUserId: '', // 收钥匙人员
        houseId: this.houseId, // 房源ID
        recordTime: '', // 收钥匙时间
        recordType: '5' // 记录类型（1:面访，2:跟进，3:查看 4:被带看 5：钥匙 6：其他） 字典表类型：record_type
      },
      edit_id: '', // 当前编辑人员id
      // 上传委托
      entrust: {
        accessoryIds: '',
        houseId: this.houseId,
        recordContent: '',
        recordTime: '',
        recordType: '6',
        propertyCertificateIds: '', // '产权url'
        entrustFileIds: '' // 委托
      },
      refHtml: null, // 节点信息
      entrustOpt: 1, // 1新增 2修改
      entrustAccessoryFile1: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      },
      entrustAccessoryFile2: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      },
      relatedPersonnelType: undefined,
      statusList: [
        {
          label: '上架',
          value: 1
        },
        {
          label: '下架',
          value: 6
        },
        {
          label: '自行成交',
          value: 3
        },
        {
          label: '无效',
          value: 4
        }
      ],
      AManager: false,
      loginUser: this.$getters.userInfo
    }
  },
  components: {
    FollowUp,
    ClaimTK,
    UploadCmp
  },
  props: {
    houseId: {
      type: String,
      require: true
    },
    controlJurisdiction: {
      type: Boolean,
      default: false
    },
    aManager: {
      type: Boolean,
      default: false
    },
    rentSaleType: {
      type: String,
      default: '1',
      require: true
    },
    housesDatas: {
      type: Object,
      default: () => {}
    },
    isRentoutSell: {
      type: String,
      default: 'rentOut'
    },
    uid: {
      type: Number
    }
  },
  watch: {
    housesDatas: {
      handler: function (newVal, oldVal) {
        this.HousesData = newVal
        console.log(this.HousesData)
      }
    },
    aManager: {
      handler: function (newVal, oldVal) {
        this.AManager = newVal
      }
    },
    immediate: true,
    deep: true
  },
  computed: {
    // 是否能领取
    isCeive () {
      const { activeNum, storeId, teamId } = this.$route.query
      const userDeptId = this.loginUser.data.user.deptId
      // console.log(userDeptId,'userDeptId')
      if (activeNum == '3' || activeNum == '1') {
        if (userDeptId == storeId || userDeptId == teamId) {
          return true
        } else {
          return false
        }
      }
      return true
    },
    lzxgPorims () {
      const arr = ['LZXG']
      const loginRole = this.loginUser.data.roles
      let status = false
      loginRole.forEach(el => {
        if (arr.includes(el)) {
          status = true
        }
      })
      console.log(status, '是否具备离职相关权限')
      return status
    },
    managePermision () {
      const arr = ['ZJL']
      const loginRole = this.loginUser.data.roles
      let status = false
      loginRole.forEach(el => {
        if (arr.includes(el)) {
          status = true
        }
      })
      return status
    }
  },
  mounted () {
    this.$emit('isHouseDetailsHeader', true)
    console.log(this.$route.query.activeNum === '1', 'tab类型')
  },
  methods: {
    // 拥有LZXG权限的管理人员 可以把离职人员的 私盘转为公盘
    updateHouseDishTypePrivateToCompany () {
      if (this.rentSaleType === '1') {
         // 租
        houseApi
        .updateHouseDishTypePrivateToCompany(this.$route.query.id)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('操作成功')
          this.getHouseDetails()
          }
        })
      } else {
        houseApi
        .updateSaleHouseDishTypePrivateToCompany(this.$route.query.id)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('操作成功')
          this.getHouseDetails()
          }
        })
       }
    },
    // 获取相关人员列表
    getRelaInfoListFn () {
      const params = {
        pageNum: this.RelaInfoPage.pageNum,
        pageSize: this.RelaInfoPage.pageSize,
        resourceId: this.houseId,
        resourceType: 1,
        rentSaleType: this.rentSaleType
      }
      houseApi
        .getRelaInfoList({
          ...params
        })
        .then((res) => {
          if (res.code === 200) {
            this.RelaInfoPage.total = res.data.total
            this.RelaInfotabledata = res.data.records
          }
        })
    },
    // 获取编辑人员团队
    getEditTeam () {
      houseApi.getDeptList().then((res) => {
        if (res.code === 200) {
          this.staffList = res.data
        }
      })
    },
    // 相关人员编辑 // 转维护人
    editStaff () {
      if (this.deitMaintainerTitle === '编辑人员') {
        const indexTeam = this.staffList.findIndex((item) => {
          return item.deptId === this.fromStaff.keyTeam
        })
        const indexry = this.editStaffList.findIndex((item) => {
          return item.userId === this.fromStaff.ketemp
        })

        console.log('===', this.staffList[indexTeam], this.editStaffList[indexry])

        const params = {
          id: this.edit_id,
          relatedDeptId: this.fromStaff.keyTeam,
          relatedDeptName: this.staffList[indexTeam].deptName,
          relatedPersonnelId: this.fromStaff.ketemp,
          relatedPersonnelName: this.editStaffList[indexry].nickName,
          rentSaleType: this.rentSaleType
        }
        houseApi.relatedPersonnelInfoEdit({ ...params }).then((res) => {
          if (res.code === 200) {
            // console.log('relatedPersonnelType', this.relatedPersonnelType, typeof this.relatedPersonnelType)
            // if (this.relatedPersonnelType === '2') {
            //   console.log('维护人')
            // }

            if (this.relatedPersonnelType !== '2') {
              this.getRelaInfoListFn()
              this.$message.success('编辑人员成功')
              this.editorShow = false
              this.getHouseDetails()
            } else {
              // 转维护人人
              const parmars = {}
              parmars.id = this.houseId
              parmars.rentSaleType = this.rentSaleType
              parmars.deptId = this.fromStaff.keyTeam
              parmars.accendantId = this.fromStaff.ketemp
              const func = this.isRentoutSell === 'sell' ? houseInfoSaleAccendant : houseApi.editMaintainer
              func(parmars).then((res) => {
                if (res.code === 200) {
                  this.getRelaInfoListFn()
                  this.$message.success('编辑并转维护人成功')
                  this.editorShow = false
                  this.getHouseDetails()
                }
              })
            }
          }
        })
      } else {
        // 转维护人人
        const parmars = {}
        parmars.id = this.houseId
        parmars.rentSaleType = this.rentSaleType
        parmars.deptId = this.fromStaff.keyTeam
        parmars.accendantId = this.fromStaff.ketemp
        const func = this.isRentoutSell === 'sell' ? houseInfoSaleAccendant : houseApi.editMaintainer
        func(parmars).then((res) => {
          if (res.code === 200) {
            this.getRelaInfoListFn()
            this.$message.success('转维护人成功')
            this.editorShow = false
            this.getHouseDetails()
          }
        })
      }
    },
    // 查看弹窗-去跟进弹窗
    goFollowUpBtn () {
      userSeeRecord().then((res) => {
        if (res.code === 200) {
          this.lookShow = false
          this.$store.commit('SET_IS_FOLLOWUP_OBJ', res.data)
        }
      })
    },
    // 认领按钮
    handleClaim () {
      this.visible = true
    },
    closeTK () {
      this.visible = false
      this.getHouseDetails()
    },
    ModalEmit () {
      this.$emit('housesDetailRef')
    },
    // 一键同步
    getSynchronization () {
      // 租房 售房请求地址一致
      const parmars = {
        id: this.houseId,
        rentSaleType: this.rentSaleType,
        channelResource: '1'
      }
      houseApi.synchronization(parmars).then((res) => {
        if (res.code === 200) {
          this.$message.success('同步成功')
        }
      })
    },
    // 编辑
    houseEdit () {
      // 帧数据后 这里应该可以获取到房源id 房源id通过路由传过去
      sessionStorage.setItem('history', JSON.stringify({ fromPage: 'edit' }))
      // console.log('99')
      if (this.isRentoutSell === 'rentOut') {
        this.$router.push({ path: '/houses/add', query: { tpfunname: '房源/编辑商铺', id: this.$route.query.id } })
      } else {
        this.$router.push({ path: '/houses/sell/add', query: { tpfunname: '房源/编辑售房', id: this.$route.query.id } })
      }
    },
    // 弹出上传钥匙弹出框
    showuploadmoadl (index, opt) {
      if (index === 6) {
        if (index === 6 && opt === 'edit') {
          this.keyTitle = '交接钥匙'
        } else {
          this.keyTitle = '上传钥匙'
        }
        this.uploadmodal = true
        this.getYSteamList()

        if (opt === 'add') {
          // 新增
        } else {
          // 编辑
          // 获取当前钥匙信息
        }
      }
      if (index === 7) {
        this.ModalEmit()
        this.uploadEntrust = true
      }
    },
    // 获取收钥匙团队
    getYSteamList () {
      houseApi.getDeptList().then((res) => {
        if (res.code === 200) {
          this.teamList = res.data
        }
      })
    },
    // 查看委托
    viewEntrust () {
      console.log('查询委托')
      this.entrustTitle = '查看委托'
      this.entrustOpt = 2
      this.$emit('loading', false)
      this.ModalEmit()
      this.uploadEntrust = true
      this.entrust.houseId = this.houseId
      this.entrust.recordType = '6' // 记录类型（1:面访，2:跟进，3:查看 4:被带看 5：钥匙 6：其他） 字典表类型：record_type
      const parmars = {
        houseId: this.houseId,
        rentSaleType: this.rentSaleType
      }
      houseApi.queryEntrust(parmars).then((res) => {
        if (res.code === 200) {
          this.$emit('loading', true)
          const data = res.data
          this.entrust = data
          this.entrust.recordTime = data.createTime
          const entrustFileList = data.entrustFileList
          const propertyCertificateList = data.propertyCertificateList

          this.entrustAccessoryFile1 = entrustFileList
            ? entrustFileList[0]
            : {
                createBy: '',
                createTime: '',
                fileName: '',
                fileSuffix: '',
                originalName: '',
                ossId: undefined,
                service: 'huawei',
                url: ''
              }
          this.entrustAccessoryFile2 = propertyCertificateList
            ? propertyCertificateList[0]
            : {
                createBy: '',
                createTime: '',
                fileName: '',
                fileSuffix: '',
                originalName: '',
                ossId: undefined,
                service: 'huawei',
                url: ''
              }

          this.entrust.entrustFileIds = this.entrustAccessoryFile1.ossId
          this.entrust.propertyCertificateIds = this.entrustAccessoryFile2.ossId
        } else {
          this.$emit('loading', true)
        }
      })
    },
    // 查看
    handleLook () {
      // 售房 租房一致的请求地址
      // 通过id查询任务信息
      const parmars = {
        id: this.houseId,
        rentSaleType: this.rentSaleType
      }
      houseApi.houseOwner(parmars).then((res) => {
        if (res.code === 200) {
          this.ownerMsgList = res.data
          this.$emit('upStatus', 4)

          userSeeRecord().then((res) => {
            if (res.code === 200) {
              if (res.data.isFollowUp === 'Y') {
                this.iscloseBtn = true
              } else {
                this.iscloseBtn = false
              }
              this.lookShow = true
            }
          })
        }
      })
    },
    // 修改房源状态
    getEditHouseInfoStatus (lastStatus) {
      const parmars = {}
      parmars.lastStatus = lastStatus
      parmars.resourceId = this.houseId
      parmars.rentSaleType = this.rentSaleType
      parmars.resourceType = 1
      const obj = this.statusList.find((el) => el.value === lastStatus)
      parmars.lastStatusName = obj && obj.label
      houseApi.editHouseInfoStatus(parmars).then((res) => {
        if (res.code === 200) {
          this.$emit('upStatus', 0)
          this.getHouseDetails()
          if (lastStatus === 1) {
            // this.$message.success('转为有效成功')
            this.$message.success('上架成功')
            return
          }
          if (lastStatus === 3) {
            this.$message.success('房源设置为自行成交成功')
            return
          }
          if (lastStatus === 4) {
            this.$message.success('房源设置为无效成功')
            return
          }
          if (lastStatus === 5) {
            this.$message.success('房源设置为无效成功')
          }
          if (lastStatus === 6) {
            // this.$message.success('转为待完善成功')
            this.$message.success('下架成功')
          }
        }
      })
    },
    // 写跟进
    followFn () {
      this.followShow = true
      this.getYSteamList()
    },
    closeModalFollowUp () {
      this.followShow = false
      this.$emit('upStatus', 1)
      this.$emit('getFollowUp')
    },
    // 获取编辑人员名称
    getEditSemp (deptId) {
      houseApi.getUserList({ deptId }).then((res) => {
        if (res.code === 200) {
          this.editStaffList = res.rows
        }
      })
    },
    // 编辑人员
    Editor (item, e) {
      this.editorShow = true
      this.getEditTeam()
      this.getEditSemp()
      this.relatedPersonnelType = item.relatedPersonnelType
      if (e === '编辑人员') {
        this.edit_id = item.id
        // 团队名称id
        this.deitMaintainerTitle = '编辑人员'
        this.fromStaff.keyTeam = item.relatedDeptId
        this.fromStaff.ketemp = item.relatedPersonnelId
        this.isuser = false
        this.getUserListItem()
      } else {
        this.deitMaintainerTitle = '转维护人'
        this.isuser = true
      }
      // Editor(1, '转维护人')
    },
    // 上传钥匙
    uploadK (item) {
      if (!this.KeysList.collectKeyTeamId) {
        this.$message.error('请选择团队')
        return
      }
      if (!this.KeysList.collectKeyUserId) {
        this.$message.error('请选择人员')
        return
      }
      if (!this.KeysList.recordTime) {
        this.$message.error('请选择时间')
        return
      }
      this.KeysList.houseId = this.houseId // 房源ID
      this.KeysList.recordType = '5' // 记录类型（1:面访，2:跟进，3:查看 4:被带看 5：钥匙 6：其他） 字典表类型：record_type
      this.KeysList.rentSaleType = this.rentSaleType
      houseApi
        .uploadKeysMethod({
          ...this.KeysList
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('上传成功')
            this.uploadmodal = false
            this.KeysList.collectKeyTeamId = ''
            this.KeysList.collectKeyUserId = ''
            this.KeysList.recordTime = ''
            this.getHouseDetails()
            this.$emit('upStatus', 0)
          }
        })
    },
    // 上传委托
    uploadTrust () {
      console.log(this.entrust, '委托信息')
      if (!this.entrust.recordTime) {
        this.$message.error('请选择委托时间')
        return
      }
      if (!this.entrust.recordContent) {
        this.$message.error('请输入委托内容')
        return
      }
      if (!this.entrust.entrustFileIds) {
        this.$message.error('请上传委托书')
        return
      }
      this.entrust.houseId = this.houseId
      this.entrust.rentSaleType = this.rentSaleType
      this.entrust.recordType = '6' // 记录类型（1:面访，2:跟进，3:查看 4:被带看 5：钥匙 6：其他） 字典表类型：record_type

      if (this.entrustOpt === 1) {
        houseApi
          .uploadEntrust({
            ...this.entrust
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success('上传委托成功')
              this.uploadEntrust = false
              this.initEntrustData()
              this.getHouseDetails()
              this.$emit('upStatus', 0)
            }
          })
      } else {
        // 修改委托
        houseApi
          .editEntrust({
            ...this.entrust
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success('修改委托成功')
              this.uploadEntrust = false
              this.initEntrustData()
              this.getHouseDetails()
            }
          })
      }
    },
    entrust1FileUrlFn (file) {
      console.log(file, file.ossId, 'file上传pdf')
      this.entrust.entrustFileIds = file.ossId + ''
      // this.fileTypesss
      this.entrustAccessoryFile1 = file
    },
    entrust2FileUrlFn (file) {
      this.entrust.propertyCertificateIds = file.ossId + ''
      this.entrustAccessoryFile2 = file
    },
    initEntrustData () {
      this.entrust = {
        accessoryIds: '',
        houseId: this.houseId,
        recordContent: '',
        recordTime: '',
        recordType: '6',
        propertyCertificateIds: '', // '产权url'
        entrustFileIds: '' // 委托
      }
      this.entrustAccessoryFile1 = {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      }
      this.entrustAccessoryFile2 = {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      }
    },

    editIdentityHandle (type, val) {
      val = val === 'Y' ? 'N' : 'Y'
      this.$emit('loading', true)

      this.param_identity = {
        id: this.houseId, //	房源ID		true
        identity: type, //	标识（1:五，2:独，3:优，4:钥匙）		true
        identityStr: val //	标识状态 字典表类型：sys_yes_no
      }
      const type_ = parseInt(type)
      const func = this.isRentoutSell === 'sell' ? houseInfoSaleidentity : houseApi.editIdentity
      func(this.param_identity).then((res) => {
        if (res.code === 200) {
          this.$emit('loading', false)
          if (type_ === 1) {
            this.HousesData.identityFive = val
          } else if (type_ === 2) {
            this.HousesData.identityAlone = val
          } else if (type_ === 3) {
            this.HousesData.identityExcellent = val
          } else if (type_ === 4) {
            this.HousesData.identityKey = val
          }
          this.$message.success('操作成功')
          this.getHouseDetails()
          //  this.$forceUpdate()
        } else {
          this.$message.error('操作失败')
          this.$emit('loading', false)
        }
      })
    },
    // 获取房源的详细信息
    getHouseDetails () {
      this.$emit('getHouseDetails')
    }
  }
}
</script>
<style lang="less" scoped>
.btn_svg {
  width: 24px;
  height: auto;
}
.preview_cover {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  cursor: pointer;
}
.preview_img {
  width: 90%;
  height: 90%;
  object-fit: contain;
  margin: 5%;
  cursor: pointer;
  border-radius: 10px;
  -wekit-border-radius: 10px;
}
.preview_video {
  width: 90vw;
  height: 90vh;
  margin: 1vh 5vw auto 5vw;
  cursor: pointer;
  border-radius: 10px;
  -wekit-border-radius: 10px;
}
.downLoad {
  cursor: pointer;
  text-align: right;
  color: var(--ThemeColor);
}
.lunbo {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.no_img_wrapper {
  width: 100%;
  height: 200px;
  text-align: center;
}
.no_img {
  width: 300px;
  height: 160px;
  background: #f2f2f2;
  margin: 20px auto 0 auto;
  img {
    width: 300px;
    height: 160px;
  }
}
.img_titlePic {
  background: #f2f2f2;
  width: 100%;
  height: 100%;
}
.detail-t {
  // cursor: pointer;
  .font_red,
  .font_light {
    // color:#ff0000;
    // cursor: pointer;
    // background: #fff1f0;
    color: #f5222d;
    // border: 1px solid #f5222d;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -ms-border-radius: 4px;
    -moz-border-radius: 4px;
    padding: 0 5px;
  }
  .font_light.icon-yuechi {
    cursor: none;
    color: gold;
    background: none;
    border: none;
  }
  .font_gray {
    cursor: pointer;
    color: #ccc;
  }
}
.icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-right: 20px;
  // cursor: pointer;
  height: 100%;
  .icon-i {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: var(--ThemeColor);
    color: white;
    text-align: center;
    line-height: 45px;
    .iconfont {
      font-size: 20px;
    }
  }
  .icon-ii {
    background-color: #31c170;
  }
}
.unclickColor {
  color: gray !important;
}
.unclickBgc {
  background-color: gray !important;
}
.detaill-img： {
  width: 30px;
  height: 30px;
}
.detail {
  width: 100%;
  padding: 20px;
  background-color: white;

  .detail-center {
    // width: 95%;
    margin: 0 auto;
    header {
      height: 66px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .title {
        font-size: 20px;
        font-weight: 700;
        color: #222222;
        margin-bottom: 0px;
      }
      .houseBtn {
        // padding: 42px 20px 0 0;
        padding: 0 20px 0 0;
        display: flex;
        position: absolute;

        right: 0;
        .Btnclaim {
          .Claim {
            width: 45px;
            height: 45px;
            line-height: 45px;
            border-radius: 50%;
            background-color: #2fba6c;
            color: white;
            text-align: center;
            cursor: pointer;
            .claim-icom {
              font-size: 22px;
            }
          }
          .clainFont {
            text-align: center;
            color: #2fba6c;
          }
        }
        .btnHouse {
          margin-left: 10px;
          .Claim {
            width: 45px;
            height: 45px;
            line-height: 45px;
            cursor: pointer;
            border-radius: 50%;
            background-color: var(--ThemeColor);
            color: white;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            .claim-icom {
              font-size: 22px;
            }
          }
          .clainFont {
            text-align: center;
            color: var(--ThemeColor);
          }
          /deep/.ant-divider-horizontal {
            margin: 9px 0;
          }
        }
      }
    }

    & > aside {
      margin-top: 20px;
      /deep/ .ant-tabs-tab {
        margin-right: 0;
        border: none;
        background-color: #ffffff;
        color: black;
        font-size: 14px;
        font-weight: bold;
      }

      /deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
        font-size: 14px;
        color: var(--ThemeColor);
        font-weight: bold;
      }
      /deep/.ant-tabs-nav {
        margin-top: -2px;
      }
      // .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
      //   height:100%;
      //   top:0;
      //   margin-top:0;
      // }
      .card-container {
        .basicInfor {
          // background-color: #6982f3;
          margin-top: 20px;
          display: flex;
          .basicInfor_left {
            // width:710px;
            width: 58%;
            height: auto;
            .img_big {
              width: 710px;
              // height:400px;
              background: #f2f2f2;
              margin-bottom: 10px;
            }
          }
          .basicInfor_right {
            width: calc(42% - 30px);
            display: flex;
            flex-direction: column;
            margin-left: 30px;
            .follow-up {
              margin-top: 56px;
              margin-bottom: 20px;
              display: flex;
              // border:1px solid #f2f6fc;
              // padding: 20px;
              .title {
                width: 90px;
                font-weight: 700;
              }
              .msg {
                width: calc(100% - 90px);
                min-width: 200px;
                > div {
                  display: flex;
                  justify-content: space-between;
                }
                .describe {
                  display: flex;
                  flex-wrap: wrap;
                  // width: 400px;
                  overflow: hidden;
                  white-space: normal;
                  word-break: break-all;
                }
                h1 {
                  font-weight: 700;
                }
              }
            }
          }
          .basicInforImg {
            width: 139px;
            height: 137px;
          }
          .basicNew {
            .basicTelte {
              width: 100%;
              display: flex;
              flex-direction: column;
              // margin-top: 15px;
              .basicTelteTu {
                display: flex;
                flex-direction: row;
                position: relative;
                // top: -3px;
                width: 200px;
                height: 40px;
                margin: 10px 0;
                // background: #f6ffed;
                justify-content: space-around;
                align-items: center;
                // box-shadow: 1px 1px 3px #ccc;
                // -webkit-box-shadow: 1px 1px 3px #ccc;
                // border-radius:3px;
                // -webkit-border-radius:3px;
                .detail-t {
                  width: 40px;
                  height: 40px;
                  text-align: center;
                  vertical-align: middle;
                  line-height: 40px;
                  box-shadow: 1px 1px 3px #ccc;
                  -webkit-box-shadow: 1px 1px 3px #ccc;
                }
                .detail-t:first-child {
                  margin-left: 0;
                }
              }
              .house-basicInfoR-warpper {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-direction: column;
                .shop_name {
                  font-size: 20px;
                  font-weight: bold;
                  color: #222;
                }
                .basicTeltexi {
                  font-size: 24px;
                  margin-right: 50px;
                  font-weight: bold;
                  color: #222222;
                  line-height: 40px;
                  display: flex;
                  flex-direction: column;
                  .tag_house_status {
                    width: 50px;
                    text-align: center;
                    margin-bottom: 20px;
                  }
                }

                .price {
                  margin-bottom: 20px;
                  .priceInfor {
                    display: flex;
                    align-items: center;
                    .priceHousin {
                      font-size: 16px;
                      font-weight: bold;
                      color: #000;
                    }
                    .priceTag {
                      background: #2fba6c;
                      color: #fff;
                      height: 17px;
                      padding: 0 5px;
                      font-size: 12px;
                      line-height: 17px;
                      margin-top: 2px;
                      margin-left: 7px;
                    }
                    .price_transferFee {
                      margin-left: 30px;
                      font-size: 14px;
                      color: #222;
                    }
                  }
                  .houseup {
                    font-size: 20px;
                    color: #222222;
                  }
                }
                .dish_tag_area_floor {
                  display: flex;
                  align-items: center;
                  .dish_tag {
                    .dish_type {
                      background: green;
                      color: #fff;
                      border-radius: 10px;
                      -webkit-border-radius: 10px;
                    }
                  }
                  .housArea {
                    margin-left: 10px;
                    .areaInfor {
                      font-weight: bolder;
                      color: #222;
                    }
                  }
                }
                .house_special {
                  width: 100%;
                  margin: 20px 0 0 0;
                }
              }
              .list_info {
                width: 100%;
                display: flex;
                flex-direction: column;
                .item_info {
                  width: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  flex-direction: row;
                  align-items: center;
                  color: #222;
                  line-height: 30px;
                  margin: 0;
                  .item_info_val {
                    margin: 0;
                    padding: 0;
                    p {
                      margin: 0;
                    }
                  }
                }
              }
            }
            .houseTag {
              margin: 10px 0px;
            }

            .houseInfor {
              display: flex;
              flex-direction: column;
              // margin-top: 13px;
              // margin-bottom: 20px;
              .address {
                margin-bottom: 20px;
                .housin {
                  font-size: 14px;
                  font-weight: bold;
                  color: #000;
                }
                .houseup {
                  font-size: 12px;
                  color: #000;
                }
              }

              .housArea {
                margin-right: 20px;
                .areaInfor {
                  font-size: 14px;
                  font-weight: bold;
                  color: #000;
                }
                .houseup {
                  font-size: 12px;
                  color: #000;
                }
              }
            }
          }

          .first-col {
            cursor: pointer;

            & > img {
              width: 200px;
              height: 200px;
              border-radius: 10px;
            }
          }

          /deep/ .ant-col-10 {
            margin-top: 28px;
          }

          .second-col {
            height: 100%;
            cursor: pointer;

            & > ul {
              list-style: none;

              & > li {
                &:nth-of-type(1) {
                  width: 280px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-top: 20px;

                  & > span {
                    font-size: 14px;
                    color: black;
                    font-weight: bold;
                  }

                  & > img {
                    width: 18px;
                    height: 18px;
                    margin-top: 6px;
                  }
                }

                &:nth-of-type(2) {
                  margin-top: 20px;

                  & > span {
                    display: inline-block;
                    width: 46px;
                    height: 28px;
                    font-size: 12px;
                    border-radius: 5px;
                    line-height: 28px;
                    text-align: center;
                    margin-right: 10px;
                  }

                  & > .green {
                    border: 1px solid #7ac756;
                    color: #7ac756;
                    background-color: #eef8e8;
                  }

                  & > .orange {
                    border: 1px solid var(--ThemeColor);
                    color: var(--ThemeColor);
                    background-color: #fdf5e9;
                  }

                  & > .red {
                    border: 1px solid #f26161;
                    color: #f26161;
                    background-color: #feeeee;
                  }
                }

                &:nth-of-type(3) {
                  // width: calc(100% - 280px - 6%);
                  margin-top: 20px;
                  color: black;

                  p {
                    &:first-of-type {
                      margin-bottom: 0px;
                      font-weight: bold;
                      font-size: 14px;
                    }
                  }

                  .mid-span {
                    display: flex;
                    align-items: center;

                    & > p {
                      margin-bottom: 0px;
                    }

                    & > span {
                      width: 53px;
                      height: 17px;
                      background-color: #2fba6c;
                      color: white;
                      line-height: 17px;
                      text-align: center;
                    }
                  }
                }
              }
            }
          }

          .last-col {
            cursor: pointer;

            & > ul {
              width: 86%;
              list-style: none;
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              margin-left: 86px;

              & > li {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                & > span {
                  display: inline-block;
                  width: 70px;
                  height: 70px;
                  background-color: var(--ThemeColor);
                  border-radius: 50%;
                }
              }
            }
          }
        }

        /* .swiper-button-prev {
          color: rgba(0, 0, 0, 0) !important;
        }
        .swiper-button-next {
          color: rgba(0, 0, 0, 0) !important;
          background: url('../detail/right.png') center center no-repeat;
        }
        .swiper-button-prev {
          color: rgba(0, 0, 0, 0) !important;
          background: url('../detail/left.png') center center no-repeat;
        }
        .swiperbox {
          position: initial;
        } */
        .lunbo {
          width: 100%;
          //height: 260px;
          margin-top: 40px;
          display: flex;
          align-items: center;
          position: relative;
          padding: 0 50px;
          & > .lunbo-child {
            margin: 0 auto;
            width: 93%;
            height: 100%;
            background-color: white;
            flex-shrink: 1;
            overflow: hidden;
            display: flex;
            justify-content: space-between;

            & > img {
              height: 100%;
              // width: 400px;
              width: 100%;
              margin-right: 10px;
              flex-shrink: 1;
            }
          }
        }
        .botText {
          display: flex;
          width: 220px;
          justify-content: space-between;
          padding-top: 30px;
          padding-bottom: 10px;

          & > p {
            &:nth-of-type(1) {
              font-size: 14px;
              color: black;
            }

            &:nth-of-type(2) {
              font-size: 14px;
              color: var(--ThemeColor);
              font-weight: bold;
            }

            &:nth-of-type(3) {
              font-size: 14px;
              color: var(--ThemeColor);
              font-weight: bold;
            }
          }
        }
        .houseSiwper {
          margin-top: 15px;
          .ant-carousel /deep/ .slick-slide {
            text-align: center;
            height: 200px;
            line-height: 200px;
            background: #79d3df;
            overflow: hidden;
          }
          .ant-carousel /deep/ .custom-slick-arrow {
            width: 25px;
            height: 25px;
            font-size: 14px;
            color: #fff;
            background-color: rgba(31, 45, 61, 0.11);
            opacity: 0.3;
          }
          .ant-carousel /deep/ .custom-slick-arrow:before {
            display: none;
          }
          .ant-carousel /deep/ .custom-slick-arrow:hover {
            opacity: 0.5;
          }

          .ant-carousel /deep/ .slick-slide h3 {
            color: #fff;
          }
        }
        .inforCenter {
          border-top: 2px solid #f2f6fc;

          & > p {
            font-size: 14px;
            font-weight: bold;
            color: black;
            padding-top: 20px;
          }

          .botInfo {
            /deep/ p {
              font-size: 14px;
              margin-bottom: 8px;

              &:nth-of-type(1) {
                color: #666;
                font-size: 14px;
              }

              &:nth-of-type(2) {
                color: black;
                font-weight: bold;
                font-size: 14px;
              }

              & > span {
                color: var(--ThemeColor);
              }
            }

            /deep/ .ant-row {
              margin-bottom: 20px;
            }
          }

          padding-bottom: 20px;
        }

        .remark {
          width: 100%;
          height: 200px;
          border: 2px solid #f2f6fc;
          border-radius: 3px;
          -webkit-border-radius: 3px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          align-items: center;
        }
        .house_intro_remark {
          width: 100%;
          height: auto;
          display: flex;
          justify-content: space-around;
          .textarea_info {
            width: 48%;
            height: auto;
            .title {
              color: #222;
              font-size: 16px;
              font-weight: 700;
              cursor: pointer;
            }
            .con {
              width: 96%;
              height: 120px;
              padding: 10px 2%;
              line-height: 30px;
              // border:1px solid var(--ThemeColor);
              border-radius: 8px;
              -webkit-border-radius: 8px;
              overflow: scroll;
              box-shadow: 1px 1px 3px var(--ThemeColor);
              -webkit-box-shadow: 1px 1px 3px var(--ThemeColor);
            }
          }
        }
        .bot-detail {
          margin: 40px 0 0 0px;
          width: 100%;
          border-top: 2px solid #f2f6fc;

          /deep/ .ant-col-12 {
            display: flex;
            align-items: center;
            padding-top: 20px;
            // padding-bottom: 20px;

            p {
              font-size: 16px;
              color: #222222;
              margin-right: 20px;
              font-weight: 700;
              display: inline-block;
              margin-bottom: 0;
            }

            span {
              font-size: 14px;
              color: var(--ThemeColor);
              font-weight: bold;
              margin-right: 10px;
            }
          }

          .bot-detail-bot {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 40px;

            .bot-detail-left {
              width: 49.5%;
              // height: 734px;
              height: auto;
              padding-bottom: 30px;
              border-radius: 3px;
              -webkit-border-radius: 3px;
              border: 2px solid #f2f6fc;
              display: flex;
              justify-content: center;

              .bot-detail-left-center {
                width: 91%;
                padding-top: 30px;
                & > ul {
                  // width: 80%;
                  list-style: none;
                  margin: 0 auto;
                  display: flex;
                  // justify-content: space-between;
                  // justify-content: space-around;
                  align-items: center;
                  // margin-left: 49px;
                  padding-left: 0px;
                  .show {
                    width: 70px;
                    height: 30px;
                    background-color: var(--ThemeColor);
                    border-radius: 30px;
                    line-height: 30px;
                    margin-right: 25px;
                    text-align: center;
                    color: white;
                  }
                  & > li {
                    width: 70px;
                    height: 30px;
                    background-color: #cccccc;
                    border-radius: 30px;
                    line-height: 30px;
                    margin-right: 25px;
                    text-align: center;
                    color: white;
                  }
                }
                .child-bot {
                  margin-top: 20px;
                  .row {
                    padding-bottom: 10px;
                    padding-top: 10px;
                    border-bottom: 1px solid #f2f6fc;
                    display: flex;
                    .col-one {
                      margin-right: 10px;
                    }
                    .col-two {
                      flex: 1;
                      .flex-warp {
                        word-break: break-all;
                      }
                    }
                    .col-three {
                      width: 140px;
                    }
                  }
                }
              }
            }

            .bot-detail-right {
              width: 49.5%;
              // padding: 30px 0 0 2px;
              border-radius: 3px;
              -webkit-border-radius: 3px;
              border: 2px solid #f2f6fc;
              // margin-right: 41px;

              .right-center {
                img {
                  width: 64px;
                  height: 64px;
                  border-radius: 64px;
                  -webkit-border-radius: 64px;
                  // margin-top: 20px;
                  margin-top: 0px;
                }
                width: 94%;
                margin: 0 auto;
                /deep/ .ant-row {
                  // margin-bottom: 30px;
                  border-bottom: 1px solid #f2f6fc;
                  padding-bottom: 15px;
                  padding-top: 15px;
                }

                /deep/.ant-col-4 {
                  & > img {
                    width: 90px;
                    height: 90px;
                    border-radius: 100px;
                  }
                }

                /deep/.ant-col-20 {
                  & > p {
                    &:nth-of-type(1) {
                      font-size: 14px;
                      color: black;
                      font-weight: bold;
                      margin-top: 14px;
                    }

                    &:nth-of-type(2) {
                      font-size: 14px;
                      color: black;

                      & > span {
                        font-size: 14px;
                        font-weight: normal;
                        color: #c2c1bf;
                        margin-left: 20px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  & > #lookModel {
    /deep/#lookUl {
      list-style: none;
      display: flex;
      justify-content: center;

      & > li {
        & > img {
          width: 200px;
          height: 200px;
          border-radius: 200px;
        }

        &:nth-of-type(2) {
          list-style: none;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
  }

  .uploads {
    /deep/.ant-upload.ant-upload-select-picture-card {
      width: 150px;
      height: 150px;
    }
    .avatar-uploader > .ant-upload {
      width: 328px;
      height: 328px;
    }

    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }

    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
  }
  .state {
    width: 50px;
    height: 50px;
    background: #ccc;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 50px;
    // margin-top: 15px;
    margin-top: 0px;
  }

  .editdept {
    display: flex;
    padding-left: 15px;
    justify-content: space-between;
  }

  .department {
    padding-top: 12px;
    font-size: 14px;
    color: black;
    font-weight: bold;
    margin-bottom: 10px;
    padding-left: 15px;
  }
}
.look {
  display: flex;
  .owner {
    width: 95px;
    height: 95px;
    border-radius: 50%;
    background-color: var(--ThemeColor);
    line-height: 95px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    margin-right: 10px;
  }
  p {
    font-size: 16px;
    font-weight: 600;
    color: #222222;
    margin-left: 20px;
  }
  .msg {
    div {
      padding-top: 20px;
    }
  }
}

.Model {
  width: 200px;
  height: 200px;
  border: 1px solid #e8e8e8;
  position: absolute;
  z-index: 999;
  background: #fff;
  top: 89px;
  right: 0;
  #components-popover-demo-placement .ant-btn {
    width: 70px;
    text-align: center;
    padding: 0;
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
.gdicon {
  .Moeldtb {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: var(--ThemeColor);
    color: white;
    text-align: center;
    line-height: 45px;
    cursor: pointer;
  }
  .Moeld {
    text-align: center;
    color: var(--ThemeColor);
  }
  .topcenter {
    position: fixed;
    top: 9%;
    left: 26%;
  }
}
.btn_more {
  color: black;
  text-align: center;
}
.btn_more:hover {
  color: var(--ThemeColor);
}
</style>
